import { css } from "../../../styled-system/css";

export const styles = {
  container: (hasAutoHeight: boolean) =>
    css({
      border: "1px solid",
      borderColor: "disabledGrey",
      borderRadius: "8px",
      backgroundColor: "white",
      position: "relative",
      overflow: "hidden",
      mobile: {
        minHeight: !hasAutoHeight ? "356px" : undefined,
      },
    }),
  heading: () =>
    css({
      margin: "baseUnit.mobile2",
    }),
  childrenWrapper: (hasBottomSpace: boolean, smallMarginTop: boolean) =>
    css({
      marginTop: smallMarginTop ? "baseUnit.mobile1" : "baseUnit.mobile2",
      marginX: "baseUnit.mobile2",
      marginBottom: hasBottomSpace ? "baseUnit.mobile2" : 0,
    }),
  button: () =>
    css({
      position: "absolute",
      bottom: 0,
      right: 0,
    }),
};
